import { Component, input } from '@angular/core';
import { ManualPaymentConfiguration } from 'app/shared/models/manual-payment-configuration.model';
import { Organisation } from 'app/shared/models/organisation.model';

@Component({
  selector: 'ez-manual-payment',
  imports: [],
  templateUrl: './manual-payment.component.html',
  styleUrl: './manual-payment.component.scss',
})
export class ManualPaymentComponent {
  readonly organisation = input.required<Organisation>();
  readonly manualPaymentConfiguration = input.required<ManualPaymentConfiguration>();
  readonly reasonForPayment = input.required<string>();

  formatIban(iban: string) {
    return iban.replace(/\w{4}(?=.)/g, '$& ');
  }
}
